shadow$provide[271] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Fragment:{enumerable:true, get:function() {
  return Fragment;
}}});
var require$_DOT__SLASH_transform_DOT_js = require("./transform.js");
class Fragment extends require$_DOT__SLASH_transform_DOT_js.Transform {
  static initClass() {
    this.traits = ["node", "include", "fragment", "bind"];
  }
  make() {
    return this._helpers.bind.make([{to:"include.shader", trait:"shader", optional:true},]);
  }
  unmake() {
    return this._helpers.bind.unmake();
  }
  change(changed, touched, _init) {
    if (touched["include"] || changed["fragment.gamma"]) {
      return this.rebuild();
    }
  }
  fragment(shader, pass) {
    if (this.bind.shader != null) {
      if (pass === this.props.pass) {
        if (this.props.gamma) {
          shader.pipe("mesh.gamma.out");
        }
        shader.pipe(this.bind.shader.shaderBind());
        shader.split();
        if (this.props.gamma) {
          shader.pipe("mesh.gamma.in");
        }
        shader.pass();
      }
    }
    return super.fragment(shader, pass);
  }
}
Fragment.initClass();

};